import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const ChemistVisitList = Loadable(lazy(() => import("./ChemistVisitList")));
const ChemistVisitForm = Loadable(lazy(() => import("./ChemistVisitForm")));

const chemistVisitRoutes = [
  {
    path: "/ChemistVisit/ChemistVisitList",
    element: <ChemistVisitList />,
    permission: PERMISSIONS.ChemistVisits.Menu,
  },
  {
    path: "/ChemistVisit/ChemistVisitForm",
    element: <ChemistVisitForm />,
  },
  {
    path: "/ChemistVisit/ChemistVisitForm/:chemistVisitId",
    element: <ChemistVisitForm />,
  },
];
export default chemistVisitRoutes;
